import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import HeroForm from './HeroForm';
// import { initialValues  } from './initialValues-testing';
import { showHeroApi, updateHeroApi, clearEditedHero } from './heroSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import uploadImage from '~/api/uploadImage';

function HeroUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues, pictureAttributeNames } = useSelector((state) => state.heroSaga.hero);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        await values.convertPictures(rawValues, pictureAttributeNames);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(rawValues, pictureAttributeNames, 'heroes');
        dispatch(updateHeroApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showHeroApi({ navigate, id }));

        return () => dispatch(clearEditedHero());
    }, []);

    return (
        <HeroForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default HeroUpdate;
